import { useCallback } from "react";
import SetSelector from "components/Inputs/SetSelector";
import { useChartSetSelectContext } from "components/charting/contexts/ChartSetSelectContext";
import { useChartCompareSetSelectContext } from "components/charting/contexts/ChartCompareSetSelectContext";
import useDataVisualizationType from "components/charting/hooks/useDataVisualizationType";
import { DataVisualizationType } from "components/charting/config/chartTypes";
import { useTranslation } from "react-i18next";
import type { MeasurementSet } from "types";

function AthleteProfileChartSetSelectorV1() {
  const { t } = useTranslation();
  const { value, options, onChange } = useChartSetSelectContext();
  const { value: selectedCompareSets } = useChartCompareSetSelectContext();
  const visType = useDataVisualizationType();

  const getOptionDisabled = useCallback(
    (option: MeasurementSet) => selectedCompareSets.includes(option),
    [selectedCompareSets]
  );

  const handleChange = useCallback((_: unknown, sets: MeasurementSet[]) => onChange(sets), [onChange]);

  const TextFieldProps =
    visType === DataVisualizationType.PROFILING_CHART
      ? { label: t("athlete_profile_chart_set_selector.set_select_label") }
      : undefined;

  return (
    <SetSelector
      value={value}
      options={options}
      onChange={handleChange}
      getOptionDisabled={getOptionDisabled}
      TextFieldProps={TextFieldProps}
    />
  );
}

export default AthleteProfileChartSetSelectorV1;
